import React, { useState, useEffect } from 'react';
import api from 'api/api';
import TimeLineStepper from 'version2/tables/timeline';
import Encountermodal from 'version2/modals/encountermodal';
import ImageModal from 'version2/modals/imagemodal';
import CombinedSummaryModal from 'version2/modals/combinedsummarymodal';
import VisitSummarymodal from 'version2/modals/visitsummarymodal';
import MRModal from 'version2/modals/mrmodal';
import { Backdrop, CircularProgress } from '@mui/material';

const ShowTimeLine = ({ patientid, usertype }) => {
  const [isTimeLineLoading, setIsTimeLineLoading] = useState(false);
  const [timelinedata, setTimeLineData] = useState({});
  const [imgdata, setImgData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [encounterdata, setEncounterdata] = useState([]);
  const [isencountermodal, setIsEncounterModal] = useState(false);
  const [isimgmodal, setIsimgmodal] = useState(false);
  const [isimgdata, setIsimgdata] = useState({});
  const [combinedsummarymodal, setCombinedsummarymodal] = useState(false);
  const [visitsummarydata, setVisitsummary] = useState({});
  const [isvisitsummarymodal, setIsvisitsummarymodal] = useState(false);
  const [ismrmodal, setIsMrmodal] = useState(false);
  const [ismrdata, setIsmrdata] = useState({});

  const fetchimgdata = async () => {
    setImgData([]);
    try {
      const imgdata = await api.get(`/v1/patients/encounter-document/${patientid}`);
      if (imgdata.status === 200) {
        setImgData(imgdata.data || []);
      } else {
        setImgData([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchtimeline = async () => {
    try {
      setTimeLineData({});
      setIsTimeLineLoading(true);
      const response = await api.get(`/v1/patients/labs-timeline/${patientid}`);
      if (response.status === 200) {
        const reversedData = Object.fromEntries(Object.entries(response?.data || {}).reverse());
        setTimeLineData(reversedData);
      } else {
        setTimeLineData({});
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsTimeLineLoading(false);
    }
  };

  const handleencounters = async (prop) => {
    try {
      setIsLoading(true);
      const response = await api.post('/v1/patients/encounter-document/by-id', {
        patient_id: patientid,
        encounter_document_id: prop?.encounter_document_id,
      });
      if (response.status === 200) {
        setEncounterdata(response?.data || []);
        setIsEncounterModal(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getimgs = async (prop) => {
    try {
      const hasImagesOrLabs = prop?.details?.images || prop?.details?.labs;
      const hasEncounterSummary = prop?.details?.encounter_summary;

      if (prop?.details?.title === "Medical Record" || Array.isArray(prop?.details?.images)) {
        setIsmrdata(prop);
        setIsMrmodal(true);
      } else if (hasImagesOrLabs && hasEncounterSummary) {
        setIsLoading(true);
        let imageResponse = null;
        let summaryResponse = null;

        if (prop?.details?.images) {
          imageResponse = await api.get(`/v1/patients/imaging-summary/${patientid}/${prop?.date}`);
        } else {
          imageResponse = await api.get(`/v1/patients/labs-readings-summary/${patientid}/${prop?.date}`);
        }

        summaryResponse = await api.get(`/v1/patients/encounter-summary/${prop?.details?.encounter_summary?.encounter_id}`);

        if (imageResponse?.status === 200) setIsimgdata(imageResponse?.data);
        if (summaryResponse?.status === 200) setVisitsummary(summaryResponse?.data);

        setCombinedsummarymodal(true);
      } else if (hasImagesOrLabs) {
        setIsLoading(true);
        let response = {};

        if (prop?.details?.images) {
          response = await api.get(`/v1/patients/imaging-summary/${patientid}/${prop?.date}`);
        } else {
          response = await api.get(`/v1/patients/labs-readings-summary/${patientid}/${prop?.date}`);
        }

        if (response?.status === 200) {
          setIsimgdata(response?.data);
          setIsimgmodal(true);
        }
      } else if (hasEncounterSummary) {
        setIsLoading(true);
        const response = await api.get(`/v1/patients/encounter-summary/${prop?.details?.encounter_summary?.encounter_id}`);
        if (response.status === 200) {
          setVisitsummary(response.data);
          setIsvisitsummarymodal(true);
        } else {
          setVisitsummary({});
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (patientid && usertype === 'PRO') {
      fetchtimeline();
      fetchimgdata();
    }
  }, [patientid, usertype]);

  return (
    <>
      <TimeLineStepper
        handleencounters={handleencounters}
        getimgs={getimgs}
        data={timelinedata}
        imgdata={imgdata}
        isTimeLineLoading={isTimeLineLoading}
      />
      <Encountermodal ismodal={isencountermodal} setIsmodal={setIsEncounterModal} data={encounterdata} />
      <ImageModal ismodal={isimgmodal} setIsModal={setIsimgmodal} imagingdata={isimgdata} />
      <CombinedSummaryModal
        ismodal={combinedsummarymodal}
        setIsModal={setCombinedsummarymodal}
        quillSummary={visitsummarydata}
        imagingdata={isimgdata}
      />
      <VisitSummarymodal ismodal={isvisitsummarymodal} setIsModal={setIsvisitsummarymodal} imagingdata={visitsummarydata} />
      <MRModal ismodal={ismrmodal} setIsModal={setIsMrmodal} imagingdata={ismrdata} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ShowTimeLine;